export const iconFontAwesomeMapsScaleUnbalancedFlip = (
	<i className="fa-solid fa-scale-unbalanced-flip"></i>
);
